// Firebase configuration
import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAlObk7ZWwF3ANkEHCbPZGSYpmmax31fZc",
  authDomain: "nvlearn-53156.firebaseapp.com",
  projectId: "nvlearn-53156",
  storageBucket: "nvlearn-53156.firebasestorage.app",
  messagingSenderId: "407013329823",
  appId: "1:407013329823:web:6a264d9b20c7b9ef40cbaa"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize services
export const auth = getAuth(app)
export const db = getFirestore(app)
export const storage = getStorage(app)
export default app

